module.exports = __webpack_public_path__ + "static/media/man.dc5161dd.png";